export default function themeToggle() {
    return {
        mode: 'dark',
        _media: null,
        _onChange: null,
        get dark() { return document.documentElement.classList.contains('dark'); },
        get isLight() { return this.mode === 'light'; },
        get ariaLabel() {
            const next = { dark: 'light', light: 'system', system: 'dark' }[this.mode];
            return `Colour theme: ${this.mode}. Switch to ${next}.`;
        },
        toggle() {
            this.mode = { dark: 'light', light: 'system', system: 'dark' }[this.mode];
            try { localStorage.setItem('theme', this.mode); } catch { /* Storage may be unavailable. */ }
            this.apply();
        },
        apply() {
            document.documentElement.classList.toggle('dark',
                this.mode === 'dark' || (this.mode === 'system' && this._media.matches));
        },
        init() {
            this._media = window.matchMedia('(prefers-color-scheme: dark)');
            try {
                const saved = localStorage.getItem('theme');
                if (['light', 'dark', 'system'].includes(saved)) this.mode = saved;
            } catch { /* Keep the designed default. */ }
            this._onChange = () => { if (this.mode === 'system') this.apply(); };
            this._media.addEventListener('change', this._onChange);
            this.apply();
        },
        destroy() {
            this._media?.removeEventListener('change', this._onChange);
        },
    };
}
